import gql from 'graphql-tag';

// store the selected phone number (can store multiple numbers for a single user)
export const MUTATION_ADD_PHONE_NUMBER = gql`
  mutation add_phone_number($accountId: Int!, $name: String!, $number: String!) {
    insert_phone_numbers(objects: { account_id: $accountId, name: $name, phone_number: $number }) {
      returning {
        account_id
        id
        name
        phone_number
      }
    }
  }
`;

// store the selected phone number (can store multiple numbers for a single user)
export const MUTATION_NAME_PHONE_NUMBER = gql`
  mutation name_phone_number($name: String!, $phone_number: String!) {
    update_phone_numbers(where: { phone_number: { _eq: $phone_number } }, _set: { name: $name }) {
      returning {
        account_id
        id
        name
        phone_number
      }
    }
  }
`;

// store the selected phone number (can store multiple numbers for a single user)
export const M_ONBOARDING_STEP = gql`
  mutation onboarding_step($user_id: Int, $onboarding_step: Int!) {
    update_users(where: { id: { _eq: $user_id } }, _set: { onboarding_step: $onboarding_step }) {
      affected_rows
    }
  }
`;
